import { Link } from "react-router-dom";

function TeachersRating() {
  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mb-1 py-1 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      
                      <div>
                        <div className="d-flex bg-white rounded-pill">
                          <form className="d-flex align-items-center me-2" onSubmit={(e) => e.preventDefault()}>
                            <span className="position-absolute ps-3 search-icon">
                              <i className="bi bi-filter-circle-fill ms-1" />
                            </span>
                            <input
                              type="text"
                              className="form-control ps-7 pe-7 rounded-3 border-0 rounded-pill"
                              placeholder="Filter Data"
                            />
                          </form>
                        </div>
                        <div className="mt-2 ms-4">
                          <nav aria-label="breadcrumb">
                            <ol class="breadcrumb pe-3">
                              <li class="breadcrumb-item">
                                <a href="#">Human Resource</a>
                              </li>
                              <li
                                class="breadcrumb-item active"
                                aria-current="page"
                              >
                                Teacher's Rating
                              </li>
                            </ol>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="">
            <div class="container-fluid mb-8 pb-5">
              <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4 mt-2">
                <table class="table mb-0 text-nowrap table-centered">
                  <thead class="table-light">
                    <tr>
                      <th>No</th>
                      <th>
                        Details
                        <i className="bi bi-info-circle ms-2 text-danger"></i>
                      </th>
                      <th>Action<i className="bi bi-person-gear ms-2 text-dark"></i></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1.</td>
                      <td className="lh-sm py-4 text-wrap">
                        <span class="text-dark">Employee ID</span> &mdash;
                        ACH0041 <br />
                        <span class="text-dark">Name</span> &mdash; POONAM PRIYA
                        <br />
                        <span class="text-dark">Rating</span> &mdash; 4.5/5
                        <br />
                        <span class="text-dark">Comment</span> &mdash; Motivates
                        students to progress
                        <br />
                        <div className="mt-2">
                          <span class="badge-dot bg-warning me-2 d-inline-block align-middle"></span>
                          Pending
                        </div>
                      </td>
                      <td>
                        <a
                          href="#"
                          class="btn btn-outline-secondary btn-sm me-1"
                        >
                          Decline
                        </a>
                        <a href="#" class="btn btn-success btn-sm">
                          Approve
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card-footer my-4 fixed-bottom offset-2">
            <nav>
              <ul class="pagination justify-content-center mb-0">
                <li class="page-item">
                  <a class="page-link disabled" href="#">
                    <i class="bi bi-chevron-left"></i>
                  </a>
                </li>
                <li class="page-item active">
                  <a class="page-link" href="#">
                    1
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    2
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    3
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    <i class="bi bi-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </main>
      </div>
    </>
  );
}

export default TeachersRating;
